import History from "./history";

const routes = [
  {
    type: "private",
    path: "/historial/:id/:type",
    roles: [
      "empleado",
      "administrador",
      "jefe",
      "alta_direccion",
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: History,
    exact: true,
  },
];

export default routes;
